import { useState, useEffect } from 'react'

const YOUTUBE_VIDEO_ID = 'HjYr7_4V180'

export default function WelcomeVideoCard({ onDismiss }) {
  const [modalOpen, setModalOpen] = useState(false)

  function openModal() {
    setModalOpen(true)
  }

  function closeModal() {
    setModalOpen(false)
  }

  // Fermer avec Escape
  useEffect(() => {
    if (!modalOpen) return
    function handleKey(e) {
      if (e.key === 'Escape') closeModal()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [modalOpen])

  return (
    <>
      {/* Carte */}
      <div className="relative bg-gray-900/80 backdrop-blur-sm border border-white/10 rounded-2xl p-6 flex flex-col gap-4">
        {/* Bouton masquer */}
        <button
          onClick={onDismiss}
          className="absolute top-3 right-3 text-white/30 hover:text-white/70 hover:bg-white/10 rounded-lg p-1 transition"
          aria-label="Masquer cette carte"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div className="text-4xl">👋</div>
        <div>
          <h2 className="text-lg font-semibold text-white">Bienvenue !</h2>
          <p className="text-white/60 text-sm mt-1">Découvre KartQuiz en vidéo en 1 minute</p>
        </div>
        <button
          onClick={openModal}
          className="btn-primary px-5 py-2.5 self-start mt-auto flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
          Voir la vidéo
        </button>
      </div>

      {/* Modal YouTube */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-4xl aspect-video rounded-2xl overflow-hidden shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            {/* Bouton fermer */}
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 z-10 bg-black/60 hover:bg-black/80 text-white rounded-full p-2 transition"
              aria-label="Fermer la vidéo"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <iframe
              src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?rel=0&modestbranding=1&autoplay=1`}
              title="Démo KartQuiz"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  )
}
